import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { switchView } from "../../../store/actions/admin/content-actions";
import { EventsState } from "../../../store/types";
import { SORT_METHODS } from "../../../store/utils/content-utils";
import Icon, { ICONS } from "../../general-ui/icon";
import IconToggle from "../../general-ui/icon-toggle/icon-toggle";
import Search from "../../general-ui/search-bar/search";
import EditProductsModal from "./edit-products";
import DeletingOptions from "./deleting-options";
import { catOrProd } from "./products-main";
import SmallSelect from "../../general-ui/select/small-select";
import './products-header.scss';

const sortByOptions = [
	{
		label: "Newest",
		value: SORT_METHODS.NEWEST
	},
	{
		label: "Oldest",
		value: SORT_METHODS.OLDEST
	},
	{
		label: "A-Z",
		value: SORT_METHODS.AZ
	},
	{
		label: "Z-A",
		value: SORT_METHODS.ZA
	},
];

interface ProductsHeaderProps {
	tabViewState: {
		tabView: catOrProd
		setTabView: (view: catOrProd) => void
	};
	sortState: {
		sortBy: string,
		setSortBy: (sort: string) => void
	};
	searchState: {
		search: string,
		setSearch: (searchTerm: string) => void
	},
	idList?: number[]
	attributeOptions?: string[];
}

export default function ProductsHeader({
	tabViewState,
	sortState,
	searchState,
	idList,
	attributeOptions
}: ProductsHeaderProps): JSX.Element {
	const {
		ProductsReducer: {
			checkedSet
		}
	} = useSelector((state: EventsState) => state);
	// const {
	// 	tabView,
	// 	setTabView
	// } = tabViewState;
	const isEditing = checkedSet.size > 0;
	return (
		<>
			<div className="products-header">
				<h1 className="products-title">Products</h1>
				<div className="products-nav">
					{isEditing
						? <DeletingOptions checkedSetSize={checkedSet.size} idList={idList!} />
						: < SubNav
							sortState={sortState}
							tabViewState={tabViewState}
							searchState={searchState}
							attributeOptions={attributeOptions}
						/>
					}
				</div>

				{/* 
				FUTURE DEV: If adding All Categories, remove the "products-nav" div above and uncomment it from below. 

				<div className="products-nav">
					<div className="products-filter">
						<input
							type="radio"
							value="categories"
							name="products-view"
							checked={tabView === "categories"}
						/>
						<label onClick={() => setTabView("categories")} htmlFor="all-categories">All Categories</label>
						<input
							type="radio"
							value="products"
							name="products-view"
							checked={tabView === "products"}

						/>
						<label onClick={() => setTabView("products")} htmlFor="all-products">All Products</label>
					</div>
					{isEditing
						? <DeletingOptions checkedSetSize={checkedSet.size} idList={idList!} />
						: < SubNav
							sortState={sortState}
							tabViewState={tabViewState}
							searchState={searchState}
						/>
					}
				</div> */}
			</div>
			<hr className="hr" />
		</>
	);
}

function SubNav({
	sortState: {
		sortBy,
		setSortBy
	},
	tabViewState: {
		tabView,
	},
	searchState: {
		setSearch
	},
	attributeOptions
}: ProductsHeaderProps) {
	const {
		ContentReducer: {
			view
		}
	} = useSelector((state: EventsState) => state);
	const dispatch = useDispatch();
	const productsView = tabView === "products";
	const categoriesView = tabView === "categories";
	const [addingProduct, setAddingProduct] = useState(false);
	const handleSearch = (searchTerm: string) => setSearch(searchTerm);
	const handleSearchClear = () => setSearch('');
	const handleItemViewToggle = () => {
		(view === "grid")
			? dispatch(switchView("list"))
			: dispatch(switchView("grid"));
	};
	return (
		<div className="products-sub-nav">
			<Search onSearch={handleSearch} onClear={handleSearchClear} />
			{productsView && (
				<>
					<SmallSelect
						placeholder="Sort by"
						options={sortByOptions}
						selected={sortBy}
						onChange={setSortBy}
					/>

					<IconToggle
						name="view toggle"
						leftValue="list"
						leftIconName={ICONS.LAYOUT_LIST}
						rightValue="grid"
						rightIconName={ICONS.LAYOUT_GRID}
						onToggle={handleItemViewToggle}
						selected={view}
					/>

					<button className="button primary small category-button" onClick={() => setAddingProduct(true)}>
						<Icon name={ICONS.ADD_PRODUCT} size={16} color="" />
						<span>Add Product</span>
					</button>
					<div className="products">
						<EditProductsModal
							isOpen={addingProduct}
							onClose={() => setAddingProduct(false)}
							attributeOptions={attributeOptions}
						/>
					</div>
				</>
			)}
			{categoriesView && (
				<button className="button primary small category-button">
					<Icon name={ICONS.ADD_CATEGORY} size={16} color="" />
					<span>Add Category</span>
				</button>
			)}
		</div>
	);
}